import React from 'react';
import { Button } from '@/components/ui/button';
import { Moon, Sun, Type } from 'lucide-react';

export const Header = ({ isDarkMode, toggleDarkMode }) => {
  const scrollToTool = () => {
    const toolSection = document.getElementById('converter-tool');
    if (toolSection) {
      toolSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/50 bg-background/80 backdrop-blur-md">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Type className="h-5 w-5" />
            </div>
            <span className="font-display text-xl font-bold text-foreground">
              CaseFlip
            </span>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleDarkMode}
              className="h-9 w-9"
              aria-label="Toggle dark mode"
            >
              {isDarkMode ? (
                <Sun className="h-5 w-5 text-muted-foreground hover:text-foreground transition-colors" />
              ) : (
                <Moon className="h-5 w-5 text-muted-foreground hover:text-foreground transition-colors" />
              )}
            </Button>
            <Button onClick={scrollToTool} className="hidden sm:inline-flex">
              Start Converting
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
